// extracted by mini-css-extract-plugin
export var cardLayout = "_82-1";
export var paginationContainer = "_82-0";